var SpinnerType = /* @__PURE__ */ ((SpinnerType2) => {
  SpinnerType2["CARY"] = "cary";
  SpinnerType2["CIRCULAR"] = "circular";
  SpinnerType2["DOTS"] = "dots";
  SpinnerType2["NONE"] = "";
  return SpinnerType2;
})(SpinnerType || {});
const SpinnerType$1 = SpinnerType;
export {
  SpinnerType,
  SpinnerType$1 as default
};
//# sourceMappingURL=WsSpinner.enum.es.js.map
